<template>
  <section class="small-12 medium-12 large-6 columns">
    <!-- /************* WHERE AND WHEN DID THE CLAIM HAPPEN *************/ -->
    <h1 v-html="vueModel.ContentViewModel.Step1Shared.StepTitle" />

    <!-- /************* WHEN CLAIM HAPPENED *************/ -->
    <Article id="step1" class="flow-group" :title="vueModel.ContentViewModel.Step1Shared.TitleWhen">
      <div class="control">
        <div class="row">
          <div class="small-12 medium-6 columns">
            <p
              class="push-up text-question"
              data-test-pick-date-label
              v-html="vueModel.ContentViewModel.Step1Shared.PickDateLabel"
            />

            <Field
              name="claim-date"
              v-slot="{ field }"
              rules="required"
              :label="vueModel.ContentViewModel.Step1Shared.ErrorMessageDate"
              v-model="stepModel.ClaimDate"
            >
              <BaseMomentDatePicker
                v-bind="field"
                :id="'claimDate'"
                :min-date="policyStartDate"
                :max-date="stepModel.InitialClaimEventDate"
                :data-test-initial-claim-event-date="vueModel.CreateClaimEntity.ClaimEventDate"
                @update:model-value="dateChanged"
                :model-value="stepModel.ClaimDate"
              />
              <ValidationError :name="field.name" />
            </Field>
          </div>
          <div v-if="stepModel.ShowTimeSelection" class="small-12 medium-6 columns">
            <p
              class="push-up text-question"
              data-test-pick-time-label
              v-html="vueModel.ContentViewModel.Step1Shared.PickTimeLabel"
            />
            <Field
              name="claim-time"
              v-slot="{ field }"
              v-model="stepModel.ClaimTime"
              rules="required"
              :label="vueModel.ContentViewModel.Step1Shared.ErrorMessageTime"
            >
              <VueSelect
                id="claim-time"
                v-bind="field"
                :start-value="initialClaimTime"
                :model-value="stepModel.ClaimTime"
                name="claim-time"
                :options="timeOptions"
                :data-test-selected-claim-time="stepModel.ClaimTime"
                :data-vv-as="vueModel.ContentViewModel.Step1Shared.ErrorMessageTime"
              />
              <ValidationError :name="field.name" />
            </Field>
          </div>
          <div class="small-12 columns">
            <Field
              v-slot="{ field, meta }"
              name="selected-date"
              :rules="'is-future-date'"
              v-model="vueModel.CreateClaimEntity.ClaimEventDate"
            >
              <input type="hidden" v-bind="field" />
              <ValidationError :name="field.name" />
            </Field>
          </div>
        </div>
      </div>
    </Article>

    <!-- /************* WHERE CLAIM HAPPENED *************/ -->
    <Article
      :title="vueModel.ContentViewModel.Step1Shared.TitelWhere"
      v-if="
        stepModel.ShowPlacesOfDamage &&
          stepModel.PlacesOfDamage &&
          vueModel.CreateClaimEntity.EventLocation !== null
      "
    >
      <Field
        name="place-of-damage"
        v-slot="{ field }"
        rules="required"
        :label="vueModel.ContentViewModel.Step1Shared.ErrorMessageWhere"
        v-model="vueModel.CreateClaimEntity.SelectedPlaceOfDamage"
      >
        <VueSelect
          id="place-of-damage"
          v-bind="field"
          :model-value="vueModel.CreateClaimEntity.SelectedPlaceOfDamage"
          :start-value="initialClaimTime"
          name="place-of-damage"
          :options="stepModel.PlacesOfDamage"
          :data-test-selected-claim-time="stepModel.ClaimTime"
          label="Label"
        />
        <ValidationError :name="field.name" />
      </Field>
    </Article>

    <!-- /************* ADDRESS WHERE CLAIM HAPPENED *************/ -->
    <Article
      v-if="vueModel.CreateClaimEntity.EventLocation !== null && stepModel.ShowAddressSelection"
      :title="vueModel.ContentViewModel.Step1Shared.TitelAddress"
      id="step2"
    >
      <div v-if="stepModel.ShowAddressTypes" class="control">
        <Field
          name="address-type"
          v-slot="{ field, meta }"
          rules="required"
          v-model="stepModel.SelectedAddressType"
        >
          <RadioGroupInline
            v-bind="field"
            :options="stepModel.AddressTypes"
            :model-value="stepModel.SelectedAddressType"
            label-prop="Label"
            value-prop="Id"
          />
          <ValidationError
            :name="field.name"
            :overrides="{ required: vueModel.ContentViewModel.Step1Shared.ErrorMessageAddress }"
            :errors="errors"
            v-show="meta.validated && !meta.valid"
          />
        </Field>
      </div>

      <div v-if="validSelectedAddress && !memberAddress" id="AddressDetails">
        <div class="control">
          <!-- /*** CLAIM ADDRESS - COUNTRY ***/ -->
          <label
            for="country"
            class="push-up text-question"
            v-html="vueModel.ContentViewModel.Step1Shared.LabelAndTooltipCountry"
          />

          <Field
            v-slot="{ field }"
            v-model="stepModel.SelectedCountry"
            :label="vueModel.ContentViewModel.Step1Shared.ErrorMessageCountry"
            name="country"
            :rules="countryValidation"
          >
            <VueSelect
              id="country"
              v-bind="field"
              v-model="stepModel.SelectedCountry"
              name="country"
              :options="stepModel.Countries"
              label="Label"
              class="v-select-search-icon"
            />
            <ValidationError :name="field.name" />
          </Field>
        </div>
        <div v-show="otherAddress && localCountry" class="control">
          <!-- /*** CLAIM ADDRESS - DK ADDRESS SEARCH ***/ -->
          <label
            for="address"
            class="text-question"
            v-html="vueModel.ContentViewModel.Step1Shared.LabelAndTooltipAddressSearch"
          />
          <!-- TODO: REFACTOR LEGACY VALIDATOR -->
          <Field
            v-slot="{ field, errors }"
            :model-value="stepModel.SelectedAddress"
            :rules="addressValidation"
            name="address"
            :label="vueModel.ContentViewModel.Step1Shared.ErrorMessageAddressSearch"
          >
            <address-search
              v-bind="field"
              :model-value="stepModel.SelectedAddress"
              @update:model-value="(newValue) => (stepModel.SelectedAddress = newValue)"
              name="address"
              :errors="errors"
            />
            <ValidationError :name="field.name" />
          </Field>
        </div>
        <div v-if="otherAddress && !localCountry" class="control">
          <div class="row">
            <!-- /*** CLAIM ADDRESS - ROAD NAME ***/ -->
            <div class="small-12 medium-6 columns">
              <label
                for="roadname"
                class="text-question"
                v-html="vueModel.ContentViewModel.Step1Shared.LabelAndTooltipAddressRoadName"
              />
              <Field
                id="roadname"
                v-model="vueModel.CreateClaimEntity.EventLocation.Street"
                :rules="roadNameValidation"
                type="text"
                name="roadname"
                :label="vueModel.ContentViewModel.Step1Shared.ErrorMessageAddressRoadName"
              />
              <ValidationError name="roadname" />
            </div>
            <!-- /*** CLAIM ADDRESS - HOUSE NUMBER ***/ -->
            <div class="small-12 medium-6 columns">
              <label
                for="housenumber"
                class="text-question"
                v-html="vueModel.ContentViewModel.Step1Shared.LabelAndTooltipAddressHouseNumber"
              />
              <Field
                id="housenumber"
                v-model="vueModel.CreateClaimEntity.EventLocation.HouseNumber"
                :rules="roadNameValidation"
                type="text"
                name="housenumber"
                :label="vueModel.ContentViewModel.Step1Shared.ErrorMessageAddressHouseNumber"
              />
              <ValidationError name="housenumber" />
            </div>
            <!-- /*** CLAIM ADDRESS - POSTAL CODE ***/ -->
            <div class="small-12 medium-6 columns">
              <label
                for="postalcode"
                class="text-question"
                v-html="vueModel.ContentViewModel.Step1Shared.LabelAndTooltipPostalCode"
              />
              <Field
                id="postalcode"
                v-model="vueModel.CreateClaimEntity.EventLocation.PostalCode"
                :rules="roadNameValidation"
                type="text"
                name="postalcode"
                :label="vueModel.ContentViewModel.Step1Shared.ErrorMessageAddressPostalCode"
              />
              <ValidationError name="postalcode" />
            </div>
            <!-- /*** CLAIM ADDRESS - CITY ***/ -->
            <div class="small-12 medium-6 columns">
              <label
                for="city"
                class="text-question"
                v-html="vueModel.ContentViewModel.Step1Shared.LabelAndTooltipCity"
              />
              <Field
                id="city"
                v-model="vueModel.CreateClaimEntity.EventLocation.City"
                :rules="roadNameValidation"
                type="text"
                name="city"
                :label="vueModel.ContentViewModel.Step1Shared.ErrorMessageAddressCity"
              />
              <ValidationError name="city" />
            </div>
          </div>
        </div>
        <!-- /*** CLAIM ADDRESS - COMMENTS ***/ -->
        <div v-show="!addressUnknown" class="control">
          <label
            for="comments"
            class="push-up text-question"
            v-html="vueModel.ContentViewModel.Step1Shared.LabelAndTooltipAddressComments"
          />
          <Field
            id="comments"
            as="textarea"
            v-model="vueModel.CreateClaimEntity.ClaimEventLocationDescription"
            type="text"
            name="comments"
            cols="30"
            rows="3"
            maxlength="100"
            :label="vueModel.ContentViewModel.Step1Shared.ErrorMessageAddressComments"
          />
        </div>
        <!-- /*** CLAIM ADDRESS - LOCATION DESCRIPTION ***/ -->
        <div v-show="addressUnknown" class="control" data-test-location-description>
          <label
            for="description"
            class="text-question"
            v-html="vueModel.ContentViewModel.Step1Shared.LabelAndTooltipLocationDescription"
          />
          <Field
            v-if="!vueModel.CreateClaimStep1Model.ShortPlaceOfDamageDescription"
            id="description"
            as="textarea"
            v-model="vueModel.CreateClaimEntity.ClaimEventLocationDescription"
            :rules="descriptionValidation"
            name="description"
            cols="30"
            rows="3"
            maxlength="300"
            :label="vueModel.ContentViewModel.Step1Shared.ErrorMessageAddressLocationDescription"
          />

          <Field
            v-if="vueModel.CreateClaimStep1Model.ShortPlaceOfDamageDescription"
            id="description"
            type="text"
            v-model="vueModel.CreateClaimEntity.EventLocation.Street"
            rules="required"
            name="description"
            maxlength="35"
            :label="vueModel.ContentViewModel.Step1Shared.ErrorMessageAddressLocationDescription"
          />
          <ValidationError name="description" />
        </div>
      </div>
    </Article>

    <Article
      v-if="!stepModel.ShowAddressSelection"
      :title="vueModel.ContentViewModel.Step1Shared.TitelAddressNoSelection"
    >
      <div class="control">
        <p data-test-address-type-static v-html="stepModel.AddressTypes[0].Label" />
      </div>
    </Article>
  </section>
</template>

<script>
import ReportClaimMixin from '../ReportClaimMixin.vue';
import timeOptions from '@/common/TimeOptions.js';
import ValidationError from '@/components/UI/ValidationError.vue';
import Utility from '@/common/UtilityFunctions.js';
import moment from 'moment';
import { defineRule, useField, useFieldError } from 'vee-validate';
import BaseMomentDatePicker from '@/components/Forms/BaseMomentDatePicker.vue';

export default {
  name: 'ReportClaimSharedStep1',
  components: {
    BaseMomentDatePicker,
    ValidationError
  },
  mixins: [ReportClaimMixin],
  props: {
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    },
    errors: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      policyStartDate: null,
      timeOptions,
      originalAddress: JSON.parse(JSON.stringify(this.vueModel.CreateClaimEntity.EventLocation)),
      stepModel: this.vueModel.CreateClaimStep1Model,
      address: null
    };
  },
  computed: {
    isMoment() {
      return moment.isMoment(this.stepModel.ClaimDate);
    },
    initialClaimTime() {
      const initialClaimEventDate = this.stepModel.InitialClaimEventDate;
      const m = initialClaimEventDate.clone();
      m.minutes(Math.floor(m.minutes() / 15) * 15);

      return m.format('HH:mm');
    },
    validSelectedAddress() {
      return this.stepModel.SelectedAddressType !== null;
    },
    memberAddress() {
      return this.stepModel.SelectedAddressType === 1;
    },
    otherAddress() {
      return this.stepModel.SelectedAddressType === 2;
    },
    addressUnknown() {
      return this.stepModel.SelectedAddressType === 3;
    },
    localCountry() {
      return this.stepModel.SelectedCountry !== null
        ? this.stepModel.SelectedCountry.Id === this.stepModel.DefaultCountry.Id
        : null;
    },
    initialClaimEventDateStringFormatted() {
      return this.vueModel.CreateClaimStep1Model.InitialClaimEventDate.format();
    },
    countryValidation() {
      return this.stepModel.SelectedAddressType !== 1 ? 'required' : '';
    },
    addressValidation() {
      return this.stepModel.SelectedAddressType === 2 && this.localCountry ? 'required' : '';
    },
    roadNameValidation() {
      return this.otherAddress && !this.localCountry ? 'required' : '';
    },
    descriptionValidation() {
      return this.stepModel.SelectedAddressType === 3 ? 'required' : '';
    },
    claimDateField() {
      return useFieldError('claim-date');
    },
    claimTimeField() {
      return useField('claim-time');
    }
  },
  watch: {
    'vueModel.CreateClaimStep1Model.SelectedAddressType': function () {
      this.$nextTick(() => {
        if (this.memberAddress) {
          this.vueModel.CreateClaimEntity.EventLocation.Street = this.originalAddress.Street;
          this.vueModel.CreateClaimEntity.EventLocation.HouseNumber =
            this.originalAddress.HouseNumber;
          this.vueModel.CreateClaimEntity.EventLocation.Floor = this.originalAddress.Floor;
          this.vueModel.CreateClaimEntity.EventLocation.Designation =
            this.originalAddress.Designation;
          this.vueModel.CreateClaimEntity.EventLocation.District = this.originalAddress.District;
          this.vueModel.CreateClaimEntity.EventLocation.PostalCode =
            this.originalAddress.PostalCode;
          this.vueModel.CreateClaimEntity.EventLocation.City = this.originalAddress.City;
        } else {
          // Reset address
          this.resetAddressProp(this.vueModel.CreateClaimEntity.EventLocation);
        }
      });

      // Reset typeaheads
      this.stepModel.SelectedAddress = null;
      this.stepModel.SelectedCountry = this.stepModel.DefaultCountry;

      // Reset description
      this.vueModel.CreateClaimEntity.ClaimEventLocationDescription = null;

      // Scroll
      if (!this.memberAddress) {
        this.$nextTick(() => {
          Utility.scrollToElem($('#AddressDetails'), 200);
        });
      }
    },
    'vueModel.CreateClaimStep1Model.SelectedAddress': function () {
      this.updateAddress(
        this.vueModel.CreateClaimEntity.EventLocation,
        this.stepModel.SelectedAddress
      );
    },
    'vueModel.CreateClaimStep1Model.SelectedCountry': function () {
      this.resetAddressProp(
        this.vueModel.CreateClaimEntity.EventLocation,
        this.stepModel.SelectedCountry !== null ? this.stepModel.SelectedCountry.Id : null
      );
    },
    'vueModel.CreateClaimStep1Model.ClaimTime': function () {
      if (this.stepModel.ClaimTime === null) {
        return;
      }

      const splitTime = this.stepModel.ClaimTime.split(':');

      this.stepModel.ClaimEventDate.hour(splitTime[0]);
      this.stepModel.ClaimEventDate.minute(splitTime[1]);
      this.stepModel.ClaimEventDate.second('0');
      this.vueModel.CreateClaimEntity.ClaimEventDate = this.stepModel.ClaimEventDate.format();

      this.showLogs();
    }
  },
  created() {
    // add new properties to model for handling date and time
    if (this.stepModel.Edited === undefined) {
      this.stepModel.ClaimDate = null;
      this.stepModel.ClaimTime = null;
      this.stepModel.Edited = false;
      this.stepModel.ClaimEventDate = this.vueModel.CreateClaimEntity.ClaimEventDate;
      this.stepModel.InitialClaimEventDate = this.vueModel.CreateClaimEntity.ClaimEventDate;
    }

    this.stepModel.ClaimEventDate = moment(this.vueModel.CreateClaimEntity.ClaimEventDate).local();
    this.stepModel.InitialClaimEventDate = moment(this.stepModel.InitialClaimEventDate).local();
    this.policyStartDate = moment(this.vueModel.CreateClaimEntity.PolicyStartDate).local();

    this.showLogs();

    // Reset adress
    if (
      this.vueModel.CreateClaimEntity.EventLocation !== null &&
      this.stepModel.SelectedAddressType === null &&
      this.stepModel.ShowAddressSelection
    ) {
      this.resetAddressProp(this.vueModel.CreateClaimEntity.EventLocation);
    }

    var vm = this;
  },
  methods: {
    dateChanged(param) {
      const paramDate = moment(param);

      this.stepModel.ClaimEventDate.year(paramDate.year());
      this.stepModel.ClaimEventDate.month(paramDate.month());
      this.stepModel.ClaimEventDate.date(paramDate.date());

      if (!this.stepModel.ShowTimeSelection) {
        this.stepModel.ClaimEventDate.hour('0');
        this.stepModel.ClaimEventDate.minutes('0');
        this.stepModel.ClaimEventDate.seconds('0');
      }

      this.stepModel.Edited = true;
      this.vueModel.CreateClaimEntity.ClaimEventDate = this.stepModel.ClaimEventDate.format();

      this.showLogs();
    },
    resetAddressSelection() {
      this.vueModel.selectedAddress = null;
      this.vueModel.selectedCountry = null;
      this.vueModel.describePlaceOfDamage = null;
    },
    showLogs() {
      // console.log('ClaimEventDate (STRING)       ', this.vueModel.CreateClaimEntity.ClaimEventDate, typeof this.vueModel.CreateClaimEntity.ClaimEventDate);
      // console.log('ClaimEventDate (MOMENT)       ', this.stepModel.ClaimEventDate.format(), typeof this.stepModel.ClaimEventDate);
      // console.log('InitialClaimEventDate (MOMENT)', this.stepModel.InitialClaimEventDate.format());
      // console.log('\n\n');
    },
    validator() {
      return this.vueModel.CreateClaimStep1Model.ClaimEventDate.isSameOrBefore(
        this.vueModel.CreateClaimStep1Model.InitialClaimEventDate
      );
    }
  }
};
</script>
